.dashboard {
  height: 100%;
}

.dashboardCard {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 24px;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 100px);
}

.cardRow {
  display: flex;
  gap: 16px;
}

.statCard {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  width: 224px;
}

.iconWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #f0fdfa;
  margin-bottom: 16px;
}

.icon {
  width: 24px;
  height: 24px;
  color: #14b8a6;
}

.statValue {
  font-size: 24px;
  font-weight: 700;
  color: #14b8a6;
  margin-bottom: 4px;
}

.statTitle {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
}

.statDescription {
  font-size: 12px;
  color: #9ca3af;
}